/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GpsrCreateProductRequest } from '../models/GpsrCreateProductRequest';
import type { GpsrCreateProductView } from '../models/GpsrCreateProductView';
import type { GpsrMessageView } from '../models/GpsrMessageView';
import type { GpsrProductListView } from '../models/GpsrProductListView';
import type { GpsrProductView } from '../models/GpsrProductView';
import type { GpsrUpdateProductRequest } from '../models/GpsrUpdateProductRequest';
import type { GpsrUploadFilesView } from '../models/GpsrUploadFilesView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GpsrService {
    /**
     * Get all GPSR products
     * @returns GpsrProductListView List of GPSR products
     * @throws ApiError
     */
    public static getAppGpsrProductsList(): CancelablePromise<Array<GpsrProductListView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/gpsr/products',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Get GPSR product by ID
     * @param productId
     * @returns GpsrProductView GPSR product details
     * @throws ApiError
     */
    public static getAppGpsrProductGet(
        productId: string,
    ): CancelablePromise<GpsrProductView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/gpsr/product/{productId}',
            path: {
                'productId': productId,
            },
            errors: {
                404: `Product not found`,
            },
        });
    }
    /**
     * Delete GPSR product
     * @param productId
     * @returns GpsrMessageView Product deleted
     * @throws ApiError
     */
    public static deleteAppGpsrProductDelete(
        productId: string,
    ): CancelablePromise<GpsrMessageView> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/gpsr/product/{productId}',
            path: {
                'productId': productId,
            },
            errors: {
                404: `Product not found`,
            },
        });
    }
    /**
     * Update GPSR product
     * @param requestBody
     * @returns GpsrMessageView Product updated
     * @throws ApiError
     */
    public static putAppGpsrProductUpdate(
        requestBody: GpsrUpdateProductRequest,
    ): CancelablePromise<GpsrMessageView> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/gpsr/product',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
                404: `Product not found`,
            },
        });
    }
    /**
     * Create new GPSR product
     * @param requestBody
     * @returns GpsrCreateProductView Product created
     * @throws ApiError
     */
    public static postAppGpsrProductCreate(
        requestBody: GpsrCreateProductRequest,
    ): CancelablePromise<GpsrCreateProductView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/gpsr/product',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Upload files to storage
     * @param formData
     * @returns GpsrUploadFilesView Files uploaded
     * @throws ApiError
     */
    public static postAppGpsrFilesUpload(
        formData: {
            files?: Array<Blob>;
        },
    ): CancelablePromise<GpsrUploadFilesView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/gpsr/files',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Delete file from storage
     * @param fileName Hashed file name
     * @returns GpsrMessageView File deleted
     * @throws ApiError
     */
    public static deleteAppGpsrFileDelete(
        fileName: string,
    ): CancelablePromise<GpsrMessageView> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/gpsr/file/{fileName}',
            path: {
                'fileName': fileName,
            },
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Download product ZIP with PDF and files
     * @param productId
     * @returns binary ZIP file download
     * @throws ApiError
     */
    public static getAppGpsrProductDownload(
        productId: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/gpsr/product/{productId}/download',
            path: {
                'productId': productId,
            },
            errors: {
                404: `Product not found`,
            },
        });
    }
}
